export type WorkItem = {
  id: string;
  title: string;
  type: "new" | "movie" | "ova" | "classic";
  category: string;
  score: number;
  year: number;
  episodes: string;
  status: string;
  studio: string;
  director: string;
  tags: string[];
  description: string;
  image: string;
};

export const works: WorkItem[] = [
  {
    id: "xinggui-yuanzhengdui",
    title: "星轨远征队",
    type: "new",
    category: "冒险",
    score: 9.1,
    year: 2026,
    episodes: "连载至第8话",
    status: "连载中",
    studio: "晨曦动画",
    director: "林澈",
    tags: ["太空", "热血", "成长"],
    description:
      "少女领航员和一群心怀梦想的少年登上探索船，穿越未知星域，在一次次危机中学会信任与担当。本作以细腻的角色塑造和宏大的太空冒险场面，成为本季最受期待的新番之一。",
    image: "https://readdy.ai/api/search-image?query=Anime%20poster%20art%20of%20young%20space%20cadets%20aboard%20a%20glowing%20starship%20deck%2C%20starry%20nebula%20background%20in%20coral%20orange%20and%20teal%20tones%2C%20vibrant%20cell%20shading%2C%20dynamic%20composition%2C%20cinematic%20warm%20lighting%2C%20high%20detail%20illustration&width=640&height=900&seq=work-star-track&orientation=portrait",
  },
  {
    id: "siji-tingyuan",
    title: "四季庭院",
    type: "new",
    category: "治愈",
    score: 8.8,
    year: 2026,
    episodes: "连载至第6话",
    status: "连载中",
    studio: "青禾映画",
    director: "苏晚",
    tags: ["日常", "温暖", "植物"],
    description:
      "在城市角落经营花店的老奶奶，与一位迷茫的年轻人相遇。四季流转，庭院里的花开与凋落，慢慢治愈了彼此内心的伤痕。画风清新，配乐温柔。",
    image: "https://readdy.ai/api/search-image?query=Gentle%20anime%20illustration%20of%20a%20cozy%20flower%20shop%20courtyard%20in%20spring%2C%20soft%20pastel%20greens%20and%20warm%20cream%20tones%2C%20blooming%20plants%2C%20soft%20sunlight%2C%20relaxing%20healing%20atmosphere%2C%20delicate%20linework%2C%20peaceful%20art&width=640&height=900&seq=work-four-seasons&orientation=portrait",
  },
  {
    id: "nihong-daima",
    title: "霓虹代码",
    type: "new",
    category: "科幻",
    score: 9.0,
    year: 2026,
    episodes: "连载至第10话",
    status: "连载中",
    studio: "零号矩阵",
    director: "顾星野",
    tags: ["赛博朋克", "悬疑", "黑客"],
    description:
      "在高度数字化的未来都市，一位天才少女黑客意外闯入被封锁的虚拟层，揭开了城市背后的数据阴谋。快节奏叙事搭配霓虹美学，是科幻爱好者的年度必看。",
    image: "https://readdy.ai/api/search-image?query=Cyberpunk%20anime%20poster%20of%20a%20young%20hacker%20girl%20in%20front%20of%20glowing%20neon%20data%20screens%2C%20teal%20and%20coral%20neon%20glow%20on%20dark%20cityscape%2C%20futuristic%2C%20cinematic%2C%20high%20contrast%2C%20vibrant%20illustration&width=640&height=900&seq=work-neon-code&orientation=portrait",
  },
  {
    id: "niguang-zhiren",
    title: "逆光之刃",
    type: "movie",
    category: "热血",
    score: 9.3,
    year: 2026,
    episodes: "剧场版 120分钟",
    status: "已完结",
    studio: "晨星制作",
    director: "沈亦鸣",
    tags: ["战斗", "剑士", "剧场版"],
    description:
      "背负旧日宿命的剑士重返故土，在漫天烽火中重新握紧逆光之刃。本片以顶级的作画与配乐，将热血战斗与家国情怀融为一体，成为今年最卖座的剧场版之一。",
    image: "https://readdy.ai/api/search-image?query=Epic%20anime%20movie%20poster%20of%20a%20swordsman%20silhouette%20holding%20a%20glowing%20blade%20against%20a%20burning%20orange%20sunset%20sky%2C%20dramatic%20lighting%2C%20battle%20scene%2C%20cinematic%20composition%2C%20warm%20tones%2C%20high%20detail&width=640&height=900&seq=work-backlight-blade&orientation=portrait",
  },
  {
    id: "yunduan-dengta",
    title: "云端灯塔",
    type: "movie",
    category: "治愈",
    score: 8.9,
    year: 2025,
    episodes: "剧场版 95分钟",
    status: "已完结",
    studio: "青禾映画",
    director: "苏晚",
    tags: ["梦境", "温情", "剧场版"],
    description:
      "住在云端灯塔的少年，每晚为迷航的梦引路。直到一位失去方向的女孩敲响他的门，两人共同踏上一段温柔的寻梦之旅。画面唯美，适合安静的夜晚观看。",
    image: "https://readdy.ai/api/search-image?query=Dreamy%20anime%20movie%20art%20of%20a%20lighthouse%20floating%20in%20soft%20clouds%20at%20twilight%2C%20warm%20amber%20and%20lavender%20pastel%20sky%2C%20gentle%20ethereal%20glow%2C%20comforting%20atmosphere%2C%20delicate%20paint%20style%2C%20soothing&width=640&height=900&seq=work-cloud-lighthouse&orientation=portrait",
  },
  {
    id: "shenkong-huisheng",
    title: "深空回声",
    type: "movie",
    category: "科幻",
    score: 9.2,
    year: 2025,
    episodes: "剧场版 110分钟",
    status: "已完结",
    studio: "零号矩阵",
    director: "顾星野",
    tags: ["太空", "悬疑", "剧场版"],
    description:
      "一支科考队在遥远的行星收到神秘信号，深入探索后却发现回声来自人类自身的记忆残响。本片以哲学思考与震撼视效，重新定义了太空科幻的叙事边界。",
    image: "https://readdy.ai/api/search-image?query=Sci-fi%20anime%20movie%20poster%20of%20an%20astronaut%20facing%20a%20huge%20mysterious%20signal%20ring%20in%20deep%20space%2C%20dark%20teal%20and%20coral%20nebula%2C%20awe%20inspiring%2C%20cinematic%2C%20dramatic%20scale%2C%20high%20detail&width=640&height=900&seq=work-deep-space-echo&orientation=portrait",
  },
  {
    id: "yinghua-xianxing",
    title: "樱花限定",
    type: "new",
    category: "校园",
    score: 8.6,
    year: 2026,
    episodes: "连载至第5话",
    status: "连载中",
    studio: "晨星制作",
    director: "陈知夏",
    tags: ["校园", "恋爱", "青春"],
    description:
      "转学而来的男生与学校摄影社社长因一场樱花摄影比赛相识，在一次次快门声中，两人的关系逐渐升温。青春的气息与细腻的情愫交织，甜而不腻。",
    image: "https://readdy.ai/api/search-image?query=Romantic%20anime%20poster%20of%20two%20high%20school%20students%20under%20falling%20cherry%20blossoms%2C%20soft%20pink%20and%20warm%20cream%20tones%2C%20youthful%20school%20setting%2C%20gentle%20sunlight%2C%20sweet%20atmosphere%2C%20delicate%20illustration&width=640&height=900&seq=work-sakura-limit&orientation=portrait",
  },
  {
    id: "muse-zhentanshe",
    title: "暮色侦探社",
    type: "classic",
    category: "悬疑",
    score: 8.7,
    year: 2023,
    episodes: "全24话",
    status: "已完结",
    studio: "零号矩阵",
    director: "沈亦鸣",
    tags: ["推理", "校园", "悬疑"],
    description:
      "只能在日落后活动的侦探社，接手一桩桩看似寻常却暗藏玄机的校园悬案。缜密的推理与恰到好处的氛围感，让它在完结多年后依然被反复回味。",
    image: "https://readdy.ai/api/search-image?query=Noir%20anime%20art%20of%20a%20mysterious%20student%20detective%20agency%20at%20dusk%2C%20dramatic%20orange%20and%20indigo%20twilight%2C%20street%20lamps%20glowing%2C%20suspenseful%20mood%2C%20cinematic%20lighting%2C%20detailed%20illustration&width=640&height=900&seq=work-twilight-detective&orientation=portrait",
  },
  {
    id: "fengqi-shanhai",
    title: "风起山海",
    type: "classic",
    category: "奇幻",
    score: 9.0,
    year: 2022,
    episodes: "全26话",
    status: "已完结",
    studio: "晨星制作",
    director: "林澈",
    tags: ["奇幻", "冒险", "东方"],
    description:
      "少年背负山海图卷踏上寻亲之路，沿途收服异兽、破解上古迷局。作品将东方神话与现代叙事结合，构建了一个宏大而自洽的奇幻世界。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20anime%20poster%20of%20a%20young%20hero%20with%20a%20glowing%20scroll%2C%20misty%20mountains%20and%20mythical%20beasts%2C%20jade%20green%20and%20coral%20tones%2C%20oriental%20ink%20style%2C%20epic%2C%20high%20detail&width=640&height=900&seq=work-wind-mountain&orientation=portrait",
  },
  {
    id: "jixie-zhixin",
    title: "机械之心",
    type: "new",
    category: "科幻",
    score: 8.9,
    year: 2026,
    episodes: "连载至第9话",
    status: "连载中",
    studio: "零号矩阵",
    director: "顾星野",
    tags: ["机甲", "热血", "机器人"],
    description:
      "一架被封印多年的旧式机甲，因少年的一句呼唤重新苏醒。人与机器的羁绊在一次次战斗中升温，也揭开了战争背后的残酷真相。机甲设计考究，打斗流畅。",
    image: "https://readdy.ai/api/search-image?query=Anime%20poster%20of%20a%20giant%20mecha%20with%20a%20glowing%20core%20beside%20a%20young%20boy%20pilot%2C%20industrial%20battlefield%20background%2C%20coral%20and%20steel%20tones%2C%20epic%20mecha%20anime%20art%2C%20dynamic%2C%20high%20detail&width=640&height=900&seq=work-machine-heart&orientation=portrait",
  },
  {
    id: "xiari-fangyingshi",
    title: "夏日放映室",
    type: "ova",
    category: "治愈",
    score: 8.5,
    year: 2025,
    episodes: "OVA 全4话",
    status: "已完结",
    studio: "青禾映画",
    director: "苏晚",
    tags: ["日常", "胶片", "夏日"],
    description:
      "老旧的社区放映室在夏日重新开张，一场场露天电影串联起邻里之间温暖的小故事。怀旧的胶片质感与治愈的叙事，让人仿佛回到了那个蝉鸣的夏天。",
    image: "https://readdy.ai/api/search-image?query=Nostalgic%20anime%20art%20of%20an%20outdoor%20summer%20film%20screening%20at%20night%2C%20projector%20light%20beam%2C%20people%20watching%20under%20stars%2C%20warm%20amber%20and%20teal%20tones%2C%20cozy%20retro%20mood%2C%20detailed%20illustration&width=640&height=900&seq=work-summer-cinema&orientation=portrait",
  },
  {
    id: "shuangzixing-wuyu",
    title: "双子星物语",
    type: "classic",
    category: "奇幻",
    score: 8.8,
    year: 2021,
    episodes: "全24话",
    status: "已完结",
    studio: "晨曦动画",
    director: "陈知夏",
    tags: ["双子", "成长", "奇幻"],
    description:
      "一对性格迥异的双胞胎在魔法学院相遇，她们在各自的道路上成长，最终在命运的交汇点并肩而行。人物关系细腻，世界观治愈而温暖。",
    image: "https://readdy.ai/api/search-image?query=Cute%20anime%20poster%20of%20twin%20girls%20in%20a%20magical%20academy%2C%20sparkling%20magic%20particles%2C%20soft%20teal%20and%20cream%20palette%2C%20whimsical%20fantasy%20school%2C%20charming%20and%20detailed%20illustration&width=640&height=900&seq=work-twins-story&orientation=portrait",
  },
  {
    id: "yehang-xinggang",
    title: "夜航星港",
    type: "new",
    category: "科幻",
    score: 8.7,
    year: 2026,
    episodes: "连载至第7话",
    status: "连载中",
    studio: "晨曦动画",
    director: "林澈",
    tags: ["太空", "贸易", "冒险"],
    description:
      "在星际贸易枢纽「星港」，一艘不起眼的货运船在各方势力间穿针引线。轻松幽默的外壳下，藏着关于自由与归属的深层思考。单元剧节奏明快，角色讨喜。",
    image: "https://readdy.ai/api/search-image?query=Anime%20art%20of%20a%20cargo%20starship%20docking%20at%20a%20neon-lit%20space%20port%20at%20night%2C%20teal%20and%20coral%20lights%2C%20hustling%20traders%2C%20cosy%20adventure%20mood%2C%20cinematic%2C%20high%20detail&width=640&height=900&seq=work-night-port&orientation=portrait",
  },
  {
    id: "rexue-lanqiu",
    title: "热血篮球少年",
    type: "classic",
    category: "热血",
    score: 9.1,
    year: 2020,
    episodes: "全36话",
    status: "已完结",
    studio: "晨星制作",
    director: "沈亦鸣",
    tags: ["运动", "热血", "青春"],
    description:
      "一支被人遗忘的篮球队，在热血少年们的带动下重新崛起。每一场比赛都全力以赴，每一次跌倒都重新站起，是运动番迷心中难以超越的经典。",
    image: "https://readdy.ai/api/search-image?query=Dynamic%20sports%20anime%20poster%20of%20teenage%20basketball%20players%20jumping%20for%20a%20shot%2C%20indoor%20gym%20under%20bright%20lights%2C%20warm%20orange%20and%20teal%20tones%2C%20high%20energy%2C%20motion%20lines%2C%20detailed%20illustration&width=640&height=900&seq=work-basketball&orientation=portrait",
  },
  {
    id: "chufang-mofashi",
    title: "厨房魔法师",
    type: "new",
    category: "治愈",
    score: 8.8,
    year: 2026,
    episodes: "连载至第8话",
    status: "连载中",
    studio: "青禾映画",
    director: "苏晚",
    tags: ["美食", "日常", "温暖"],
    description:
      "深夜的小巷里藏着一家只对失落的人开放的料理店，店主能用食材施展小小的「魔法」。每一集一道菜，每一道菜治愈一个人，温暖又下饭。",
    image: "https://readdy.ai/api/search-image?query=Warm%20anime%20art%20of%20a%20chef%20cooking%20in%20a%20cozy%20night%20kitchen%2C%20steam%20and%20golden%20light%2C%20delicious%20food%2C%20soft%20cream%20and%20amber%20tones%2C%20comforting%20atmosphere%2C%20detailed%20illustration&width=640&height=900&seq=work-kitchen-magic&orientation=portrait",
  },
  {
    id: "shikong-xinjian",
    title: "时空信笺",
    type: "movie",
    category: "恋爱",
    score: 9.0,
    year: 2024,
    episodes: "剧场版 100分钟",
    status: "已完结",
    studio: "晨曦动画",
    director: "陈知夏",
    tags: ["穿越", "恋爱", "剧场版"],
    description:
      "能够寄往过去的信笺，让两个相隔多年的灵魂得以对话。当真相揭晓，那句来不及说出口的话终于被好好送达。情感细腻，泪点与温暖并存。",
    image: "https://readdy.ai/api/search-image?query=Romantic%20fantasy%20anime%20movie%20art%20of%20letters%20flying%20through%20a%20starlit%20sky%20between%20two%20lovers%2C%20soft%20blue%20and%20coral%20glow%2C%20melancholy%20yet%20warm%20mood%2C%20cinematic%2C%20delicate%20detail&width=640&height=900&seq=work-time-letter&orientation=portrait",
  },
  {
    id: "shenyuan-huiyin",
    title: "深渊回响",
    type: "ova",
    category: "悬疑",
    score: 8.6,
    year: 2024,
    episodes: "OVA 全6话",
    status: "已完结",
    studio: "零号矩阵",
    director: "顾星野",
    tags: ["悬疑", "暗黑", "解谜"],
    description:
      "一座被迷雾笼罩的孤岛，六位来客各自背负秘密。OVA以紧凑的六集篇幅，构建了一出层层反转的群像谜局，结局令人拍案。",
    image: "https://readdy.ai/api/search-image?query=Dark%20mystery%20anime%20art%20of%20a%20lonely%20island%20under%20fog%20and%20moonlight%2C%20shadowy%20figures%2C%20deep%20teal%20and%20coral%20accents%2C%20suspenseful%2C%20cinematic%20mood%2C%20high%20detail&width=640&height=900&seq=work-abyss-echo&orientation=portrait",
  },
  {
    id: "yanhua-dahuipian",
    title: "烟火大会篇",
    type: "ova",
    category: "校园",
    score: 8.4,
    year: 2025,
    episodes: "OVA 全3话",
    status: "已完结",
    studio: "晨星制作",
    director: "陈知夏",
    tags: ["夏日祭", "青春", "OVA"],
    description:
      "人气校园番的夏日特别篇，将镜头对准了烟火大会前夜的小镇。少年少女们的心事随着升空的烟火一同绽放，是粉丝们珍藏的限定回忆。",
    image: "https://readdy.ai/api/search-image?query=Beautiful%20anime%20art%20of%20summer%20festival%20fireworks%20over%20a%20town%2C%20silhouettes%20of%20youths%20in%20yukata%2C%20warm%20and%20teal%20night%20sky%2C%20celebratory%20mood%2C%20nostalgic%2C%20high%20detail&width=640&height=900&seq=work-fireworks&orientation=portrait",
  },
];